
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CentralizedLoadingService } from 'src/app/Services/centralizedLoading.service';

@Component({
    selector: 'tl-global-loader',
    templateUrl: './global-loader.component.html',
    styleUrls: ['./global-loader.component.scss'],
    imports: []
})
export class GlobalLoaderComponent implements OnInit, OnDestroy {
  isLoading = false;
  activeRequestsCount = 0;
  private subscription: Subscription;

  constructor(private centralizedLoadingService: CentralizedLoadingService) { }

  ngOnInit(): void {
    this.subscription = this.centralizedLoadingService.loading$.subscribe(loading => {
      this.isLoading = loading;
      if (this.isLoading) {
        jQuery('.overlay').show();
      } else {
        jQuery('.overlay').hide();
      }
      this.activeRequestsCount = this.centralizedLoadingService.getActiveRequestsCount();
    });
  }

  ngOnDestroy(): void {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
